import view from 'bundle-text:../dom/removeAccount.html'; // eslint-disable-line
import app from './app';

export default () => {
  const content = document.createElement('div');

  content.classList.add(
    'align-items-center',
    'd-flex',
    'justify-content-center',
    'w-100',
  );
  content.innerHTML = view;

  document.title = `${app.run.settings.view.removeAccount.pageTitle}${app.run.settings.siteTitleSeparator}${app.run.settings.siteTitle}`;

  const form = content.querySelector('#app-form-removeAccount');
  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const data = {};
    const formData = new FormData(form);

    const failure = content.querySelector('#app-removeAccount-failure');
    const success = content.querySelector('#app-removeAccount-success');

    formData.forEach((value, key) => {
      data[key] = value;
    });

    const json = JSON.stringify(data);

    const request = new Request(form.action, {
      body: json,
      headers: app.run.headers,
      method: 'POST',
    });

    fetch(
      request
    ).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`);
      }
      return response.json();
    }).then((data) => {
      form.classList.add('d-none');

      failure.classList.add('d-none');
      success.classList.remove('d-none');
    }).catch((error) => {
      form.classList.remove('d-none');

      failure.classList.remove('d-none');
      success.classList.add('d-none');
    });
  });

  return content;
};
